<div class="product-card-skeleton">
  <div class="skeleton-card">
    <div class="skeleton-header">
      <div class="skeleton-title skeleton-shimmer"></div>
      <div class="skeleton-badge skeleton-shimmer"></div>
    </div>
    
    <div class="skeleton-image skeleton-shimmer"></div>
    
    <div class="skeleton-content">
      <div class="skeleton-text skeleton-shimmer"></div>
      <div class="skeleton-text skeleton-shimmer"></div>
      <div class="skeleton-text skeleton-shimmer short"></div>
    </div>
    
    <div class="skeleton-footer">
      <div class="skeleton-price skeleton-shimmer"></div>
      <div class="skeleton-button skeleton-shimmer"></div>
    </div>
  </div>
</div>

